/**
 * @generated SignedSource<<68b549288c06e94bc2fd5e6530b0a63c>>
 * @relayHash 2f6f1b80490c2656f7a7858bc281fe06
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 70de7f4c57c8bd9121eb6d052304407d16732d03e2874b0b6edf8bcef5bf9d5f

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraBoardSwimlaneStrategy = "ASSIGNEE_UNASSIGNED_FIRST" | "ASSIGNEE_UNASSIGNED_LAST" | "CUSTOM" | "EPIC" | "ISSUE_CHILDREN" | "ISSUE_PARENT" | "NONE" | "PARENT_CHILD" | "PROJECT" | "REQUEST_TYPE" | "%future added value";
export type JiraIssueSearchOperationScope = "NIN_GLOBAL" | "NIN_GLOBAL_SCHEMA_REFACTOR" | "NIN_GLOBAL_SHADOW_REQUEST" | "NIN_PROJECT" | "NIN_PROJECT_SCHEMA_REFACTOR" | "NIN_PROJECT_SHADOW_REQUEST" | "TIMELINE_PROJECT" | "%future added value";
export type JiraJqlScopeInput = {
  backlog?: JiraJqlBacklogInput | null | undefined;
  board?: JiraJqlBoardInput | null | undefined;
  list?: JiraIssueSearchScope | null | undefined;
  plan?: JiraJqlPlanInput | null | undefined;
  project?: JiraJqlProjectInput | null | undefined;
};
export type JiraJqlBacklogInput = {
  boardId: AGG$Long;
};
export type JiraJqlBoardInput = {
  boardId: AGG$Long;
  swimlaneStrategy?: JiraBoardSwimlaneStrategy | null | undefined;
};
export type JiraIssueSearchScope = {
  operationScope?: JiraIssueSearchOperationScope | null | undefined;
  projectKey?: string | null | undefined;
};
export type JiraJqlPlanInput = {
  planId: AGG$Long;
  scenarioId?: AGG$Long | null | undefined;
};
export type JiraJqlProjectInput = {
  projectKey?: string | null | undefined;
};
export type JQLBuilderWithAIFilterRefinementQuery$variables = {
  cloudId: string;
  isFilterRefinementEnabled: boolean;
  scope?: JiraJqlScopeInput | null | undefined;
};
export type JQLBuilderWithAIFilterRefinementQuery$data = {
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"FilterRefinement">;
  } | null | undefined;
};
export type JQLBuilderWithAIFilterRefinementQuery = {
  response: JQLBuilderWithAIFilterRefinementQuery$data;
  variables: JQLBuilderWithAIFilterRefinementQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarfiltercomponentrelayprovider": isJiraAiAgentAvatarFilterComponentEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarfiltercomponentrelayprovider: {
    readonly get: () => boolean;
  };
});

import isJiraAiAgentAvatarFilterComponentEnabled_provider from '@atlassian/jira-relay-provider/src/jira-ai-agent-avatar-filter-component.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isFilterRefinementEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scope"
},
v3 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v4 = {
  "kind": "Variable",
  "name": "scope",
  "variableName": "scope"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "JQLBuilderWithAIFilterRefinementQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "isFilterRefinementEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "assignees",
                    "value": 50
                  },
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "kind": "FragmentSpread",
                "name": "FilterRefinement"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarfiltercomponentrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "JQLBuilderWithAIFilterRefinementQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "isFilterRefinementEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v3/*: any*/)
                ],
                "concreteType": "JiraJqlBuilder",
                "kind": "LinkedField",
                "name": "jqlBuilder",
                "plural": false,
                "selections": [
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 50
                      },
                      {
                        "kind": "Literal",
                        "name": "jqlTerm",
                        "value": "assignee"
                      },
                      (v4/*: any*/)
                    ],
                    "concreteType": "JiraJqlFieldValueConnection",
                    "kind": "LinkedField",
                    "name": "fieldValues",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraJqlFieldValueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "jqlTerm"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "displayName"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                      },
                                      {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarfiltercomponentrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "appType"
                                              }
                                            ],
                                            "type": "AppUser"
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "id"
                                      }
                                    ]
                                  }
                                ],
                                "type": "JiraJqlUserFieldValue"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "70de7f4c57c8bd9121eb6d052304407d16732d03e2874b0b6edf8bcef5bf9d5f",
    "metadata": {},
    "name": "JQLBuilderWithAIFilterRefinementQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarfiltercomponentrelayprovider": isJiraAiAgentAvatarFilterComponentEnabled_provider
    }
  }
};
})();

(node as any).hash = "7b17dd8350c7f84981399fec05652619";

export default node;
